import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { uploadFile } from "../services/audios";
import { useGlobalState } from "../context/GlobalStateContext";

const FileUpload = ({ groupName }) => {
  const { sendSocketMessage } = useGlobalState();
  const [isHovered, setIsHovered] = React.useState(false);

  const iconUpload = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        opacity: isHovered ? 1 : 0.7,
        cursor: "pointer",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        transform: isHovered ? "scale(1.1)" : "scale(1)",
        color: isHovered ? "#d4af37" : "currentColor",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M12 15V3M12 3L8 7M12 3L16 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17L2 19C2 20.1046 2.89543 21 4 21L20 21C21.1046 21 22 20.1046 22 19V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file.type === "audio/mpeg") {
        // Normalize filename: lowercase with underscores
        const normalizedFileName = file.name
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_().-]/g, "");

        try {
          await uploadFile(groupName, normalizedFileName, file);
          sendSocketMessage("REFRESH_AUDIOLIST", null);
        } catch (error) {
          const errorMessage =
            error.response?.data?.error ||
            error.message ||
            "Errore durante l'upload del file";
          alert(`Errore: ${errorMessage}`);
        }
      } else {
        alert("Formato file non valido. Solo file MP3 sono accettati.");
      }
    },
    [groupName, sendSocketMessage],
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {iconUpload}
    </div>
  );
};

export default FileUpload;
